import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.31 10.12a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5Zm-10.91 0a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5ZM8 4.88c1.87 0 3.9 1.87 5.89 2.67h.36c2.38 0 3 1 3.34 1.81 0 .1.29.19.31.29.16.67 0 1.94-.2 1.95h-1.05v-.07a2.24 2.24 0 0 0-2.32-2.15A2.24 2.24 0 0 0 12 11.53v.07H5.74v-.07a2.24 2.24 0 0 0-2.32-2.15 2.24 2.24 0 0 0-2.32 2.15v.07H.42C-.11 11.6 0 9.66 0 8.88c0-.31.28-.24.38-.54.42-1.2 1.5-3.46 4.15-3.46Z",
      style: {"fill":"var(--theme-texte)","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "vp"}) } }